export default __webpack_public_path__ + "static/media/headshot.0632b6df.jpg";